import { AppConfig } from './appConfig';

let appConfig: AppConfig = {} as AppConfig;

export const loadConfig = async (): Promise<void> => {
  const res = await fetch('/assets/appConfig.json');
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  appConfig = (await res.json()) as AppConfig;
};

export const config = (): AppConfig => appConfig;

export default loadConfig;
